import { AfterViewInit, Component } from '@angular/core';
import {AuthenticationService} from "../../../authentication/authentication.service";
import {EventService} from "../../../core/services/event.service";
import {ChangeEventDialogComponent} from "../dialogs/change-event-dialog/change-event-dialog.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { ImageService } from '../../services/image.service';
import { Angulartics2 } from 'angulartics2';
import {ChangeNationalTeamDialogComponent} from '../dialogs/change-national-team-dialog/change-national-team-dialog.component';
import {NationalTeamsService} from '../../services/national-teams.service';
import {FundraisingViewService} from '../../services/fundraising-view.service';

@Component({
    selector: 'cat-top-bar',
    templateUrl: './top-bar.component.html'
})
export class TopBarComponent implements AfterViewInit {
    avatar: string;
    switchEvent = false;
    switchNationalTeam = false;

    constructor(
        private authService: AuthenticationService,
        public modalService: NgbModal,
        public eventService: EventService,
        public nationalTeamsService: NationalTeamsService,
        public fundraisingViewService: FundraisingViewService,
        private imageService: ImageService,
        private angulartics2: Angulartics2
    ) {
        //avoid broken image and null request on initial page load
        this.avatar = this.imageService.formatUrl(null);
    }

    ngAfterViewInit() {
        this.eventService.onEventInit.subscribe(() => {
            this.handleAvatar();
        });
        this.eventService.onEventChange.subscribe(() => {
            this.handleAvatar();
        });
        this.eventService.onGqlReload.subscribe(() => {
            this.handleAvatar();
        });
        const that = this;

        window.addEventListener('orientationchange', function() {
            // Announce the new orientation number
            if (that.switchEvent) {
                that.closeEventSwitch();
                that.openChangeEventModal();
            } else if (that.switchNationalTeam) {
                that.closeNationalTeamSwitch();
                that.openChangeNationalTeamModal();
            }
        }, false);
    }

    closeEventSwitch() {
        this.switchEvent = false;
    }

    closeNationalTeamSwitch() {
        this.switchNationalTeam = false;
    }

    handleAvatar() {
        this.avatar = this.imageService.formatUrl(this.eventService.selectedEvent.gql.Participant[0].individualConstituent.imagePath);
    }

    logout() {
        this.authService.logout();
        this.angulartics2.eventTrack.next({
            action: 'Logout',
            properties: {category: 'Header'}
        });
    }

    openChangeEventModal() {
        this.modalService.open(ChangeEventDialogComponent);
    }

    openChangeNationalTeamModal() {
        this.modalService.open(ChangeNationalTeamDialogComponent);
    }

    onEventSelect(event) {
        this.eventService.setEvent(event);
    }

    openSwitchEvent() {
        this.switchEvent = !this.switchEvent;
    }

    onNationalTamSelect(nationalTeam) {
        this.nationalTeamsService.setNationalTeam(nationalTeam);
    }

    openSwitchNationalTeam() {
        this.switchNationalTeam = !this.switchNationalTeam;
    }

    canManageOnlyNationalTeamsView() {
        return !this.canManageEvents() && this.canManageNationalTeams();
    }

    canManageOnlyEventsView() {
        return this.canManageEvents() && !this.canManageNationalTeams();
    }

    canManageNationalTeamsAndEventsView() {
        return this.canManageEvents() && this.canManageNationalTeams();
    }

    canManageNationalTeams() {
        return this.listNotEmpty(this.nationalTeamsService.getAllNationalTeams());
    }

    canManageEvents() {
        return this.listNotEmpty(this.eventService.events) || this.listNotEmpty(this.eventService.pastEvents);
    }

    isManageNationalTeamsViewVisible() {
        return localStorage.getItem('org.lls.last-view') === 'national-teams' && this.canManageNationalTeams();
    }

    isManageEventsViewVisible() {
        return localStorage.getItem('org.lls.last-view') === 'events' && this.canManageEvents();
    }

    private listNotEmpty(list) {
        return !!list && list.length > 0;
    }
}
